import { graphql, StaticQuery } from 'gatsby';
import React, { Component } from 'react';
import styled from 'styled-components'
import { A, P, theme } from '@upsolve/ui';

import ImageInContext from '../Media/ImageInContext';
import Page from './Page.div';

const AboutContainer = styled.div`
  background: ${theme.colors.white['800']};
  text-align: center;
  div.images {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      &.team {
        border-radius: 210px;
        height: 210px;
        width: 210px;
        min-width: 210px;
        max-width: 210px;
        border: 6px solid ${props => props.theme.colors.brand['500']};
      }
      &:not(.team) {
        width: 140px;
        height: 100%;
        max-width: 140px;
        max-height: 60px;
        @media(max-width: 45em) {
          margin: 0.75em;
        }
      }
    }
    @media(max-width: 45em) {
      flex-direction: column;
    }
  }
`;

class AboutPanel extends Component {
  render() {
    return (
      <AboutContainer id="about">
        <Page padding="2em 1em">
          <StaticQuery
            query={graphql`
              query AboutPictures {
                team: file(base: { eq: "team.jpg" }) {
                  childImageSharp {
                    fluid(quality: 90) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                lsc: file(base: { eq: "lsc.png" }) {
                  childImageSharp {
                    fluid(quality: 90) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                robinHood: file(base: { eq: "robinhood.png" }) {
                  childImageSharp {
                    fluid(quality: 90) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                harvard: file(base: { eq: "harvard.png" }) {
                  childImageSharp {
                    fluid(quality: 90) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
                fastForward: file(base: { eq: "fast-forward.png" }) {
                  childImageSharp {
                    fluid(quality: 90) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            `}
            render={(data) => {
              return (
                <div className="images">
                  <ImageInContext alt="Legal Services Corporation" fluid={data.lsc.childImageSharp.fluid} />
                  <ImageInContext alt="Robin Hood" fluid={data.robinHood.childImageSharp.fluid} />
                  <ImageInContext className="team" alt="The Upsolve Team" fluid={data.team.childImageSharp.fluid} />
                  <ImageInContext alt="Harvard University" fluid={data.harvard.childImageSharp.fluid} />
                  <ImageInContext alt="Fast Forward" fluid={data.fastForward.childImageSharp.fluid} />
                </div>
              );
            }}
          />
          <P><b>Upsolve is a 501(c)(3) legal aid nonprofit that started in 2016</b>. Our mission is to help low-income Americans in financial distress get a fresh start through Chapter 7 bankruptcy at no cost. We do this by combining the power of technology with attorneys. Spun out of Harvard Law School, <A href="/team/">our team</A> includes lawyers, engineers, and judges. We have <A href="/supporters/">mission-driven funders</A> that include the U.S. government, former Google CEO Eric Schmidt, and private charities.</P>
          <P>To learn more, <A href="/reviews/">read our reviews from past clients</A>, or read our <A href="/press/">press coverage</A>.</P>
        </Page>
      </AboutContainer>
    );
  }
}

export default AboutPanel;
